import type { Episode } from '@/types/content';

export const episodes: Episode[] = [
  {
    id: 1,
    number: 1,
    title: '初次登门',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20still%20from%20a%20modern%20Chinese%20family%20drama%2C%20a%20nervous%20young%20man%20standing%20at%20an%20apartment%20doorway%20holding%20a%20fruit%20gift%20box%2C%20warm%20golden%20evening%20light%20through%20the%20hallway%20window%2C%20soft%20shadows%2C%20shallow%20depth%20of%20field%2C%20restrained%20emotional%20atmosphere%2C%20high%20detail%20editorial%20photography%20with%20warm%20neutral%20tones&width=640&height=360&seq=drama-ep01-cover-2024&orientation=landscape',
    airDate: '2024-03-05',
    director: '沈亦航',
    writer: '周晚棠 / 林澈',
    duration: '45分钟',
    synopsis:
      '恋爱两年的陈默终于鼓起勇气，决定第一次正式登门拜访女友林夏的母亲赵慧兰。他精心准备了礼物，反复练习开场白，却在门口撞见了意想不到的场面。赵慧兰冷静而克制，几句话便让这位年轻人认清了自己的位置——也让他隐约察觉到，这个家里藏着一段未曾说出口的往事。',
    highlight: '一句「你了解我女儿多少」瞬间点燃全剧张力。',
    actorIds: [1, 2, 3],
  },
  {
    id: 2,
    number: 2,
    title: '一桌家宴',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20still%20from%20a%20modern%20Chinese%20family%20drama%2C%20a%20round%20dinner%20table%20with%20home%20cooked%20dishes%20under%20warm%20lamp%20light%2C%20three%20people%20seated%20with%20polite%20tension%2C%20steaming%20soup%2C%20soft%20interior%20shadows%2C%20shallow%20depth%20of%20field%2C%20intimate%20restrained%20mood%2C%20editorial%20photography%20with%20warm%20amber%20tones&width=640&height=360&seq=drama-ep02-cover-2024&orientation=landscape',
    airDate: '2024-03-06',
    director: '沈亦航',
    writer: '周晚棠 / 林澈',
    duration: '45分钟',
    synopsis:
      '饭桌成了彼此试探的战场。赵慧兰用最寻常的家常菜，一句句看似关心实则在掂量的问话，把陈默的家境、规划、性格摸了个清楚。林夏在母亲与恋人之间左右为难，第一次意识到，这段感情真正的考验或许并不在彼此，而在饭桌的另一端。',
    highlight: '家常菜背后的层层试探，是本剧最耐看的群戏。',
    actorIds: [1, 2, 3, 8],
  },
  {
    id: 3,
    number: 3,
    title: '善意的隐瞒',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20still%20from%20a%20modern%20Chinese%20family%20drama%2C%20a%20young%20woman%20answering%20a%20phone%20quietly%20in%20a%20bedroom%20at%20night%2C%20cool%20moonlight%20through%20curtains%2C%20worried%20expression%2C%20soft%20shadows%2C%20shallow%20depth%20of%20field%2C%20melancholic%20quiet%20mood%2C%20editorial%20photography%20with%20cool%20blue%20neutral%20tones&width=640&height=360&seq=drama-ep03-cover-2024&orientation=landscape',
    airDate: '2024-03-07',
    director: '沈亦航',
    writer: '周晚棠 / 林澈',
    duration: '45分钟',
    synopsis:
      '林夏无意中发现母亲最近频繁接到一通陌生来电，却每次都避开她接听。她向陈默倾诉，两人决定不再追问，给彼此留出空间。然而这个「善意的隐瞒」，恰恰成了后续所有误会的开端。',
    highlight: '深夜的一通电话，为全剧埋下第一颗定时炸弹。',
    actorIds: [1, 2, 3],
  },
  {
    id: 4,
    number: 4,
    title: '意外的来电',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20still%20from%20a%20modern%20Chinese%20family%20drama%2C%20a%20middle%20aged%20woman%20sitting%20alone%20on%20a%20sofa%20holding%20an%20old%20landline%20phone%2C%20dim%20living%20room%2C%20single%20warm%20lamp%2C%20deep%20shadows%2C%20thoughtful%20sorrowful%20expression%2C%20shallow%20depth%20of%20field%2C%20editorial%20photography%20with%20muted%20warm%20tones&width=640&height=360&seq=drama-ep04-cover-2024&orientation=landscape',
    airDate: '2024-03-08',
    director: '沈亦航',
    writer: '周晚棠 / 林澈',
    duration: '45分钟',
    synopsis:
      '赵慧兰接到一通来自旧友的电话，勾起了她尘封多年的记忆。年轻时她曾为了家庭放弃了一次重要机会，如今旧友带着当年的遗憾与愧疚重新出现。她表面上云淡风轻，挂断电话后却独自坐了很久。',
    highlight: '赵慧兰首次露出柔软的一面，角色瞬间立体起来。',
    actorIds: [2, 5, 8],
  },
  {
    id: 5,
    number: 5,
    title: '周末家访',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20still%20from%20a%20modern%20Chinese%20family%20drama%2C%20a%20young%20couple%20walking%20along%20a%20sunlit%20residential%20alley%20carrying%20grocery%20bags%2C%20golden%20afternoon%20light%20through%20green%20trees%2C%20relaxed%20tender%20expressions%2C%20shallow%20depth%20of%20field%2C%20warm%20hopeful%20mood%2C%20editorial%20photography%20with%20warm%20sunlit%20tones&width=640&height=360&seq=drama-ep05-cover-2024&orientation=landscape',
    airDate: '2024-03-09',
    director: '沈亦航',
    writer: '周晚棠 / 林澈',
    duration: '45分钟',
    synopsis:
      '陈默再次登门，这次他主动下厨帮忙，试图用行动证明自己的诚意。赵慧兰的态度依旧不冷不热，却在看到他默默修好漏水的水龙头后，眼神有了一丝松动。林夏看在眼里，第一次觉得事情或许有转机。',
    highlight: '厨房里的并肩，是全剧难得的温柔时刻。',
    actorIds: [1, 2, 3],
  },
  {
    id: 6,
    number: 6,
    title: '一张旧照片',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20still%20from%20a%20modern%20Chinese%20family%20drama%2C%20close%20up%20of%20aged%20faded%20photograph%20held%20by%20hands%20under%20warm%20lamp%2C%20blurred%20family%20portrait%20from%20the%20past%2C%20dust%20motes%20in%20light%2C%20deep%20nostalgic%20shadows%2C%20shallow%20depth%20of%20field%2C%20melancholic%20memory%20mood%2C%20editorial%20photography%20with%20sepia%20warm%20tones&width=640&height=360&seq=drama-ep06-cover-2024&orientation=landscape',
    airDate: '2024-03-10',
    director: '沈亦航',
    writer: '周晚棠 / 林澈',
    duration: '45分钟',
    synopsis:
      '陈默无意中在林家书架上看到一张旧照片，照片里的人与赵慧兰极为相像。他随口一问，却让气氛骤然凝固。林夏也从未见过这张照片，母亲含糊带过，只说是「很久以前的朋友」。真相的轮廓，第一次浮出水面。',
    highlight: '一张照片，牵出母女两代人的秘密。',
    actorIds: [1, 2, 3, 5],
  },
  {
    id: 7,
    number: 7,
    title: '误会丛生',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20still%20from%20a%20modern%20Chinese%20family%20drama%2C%20a%20young%20woman%20arguing%20with%20her%20mother%20in%20a%20corridor%2C%20tense%20body%20language%2C%20cool%20grey%20daylight%20through%20window%2C%20shallow%20depth%20of%20field%2C%20confrontational%20restrained%20mood%2C%20high%20detail%20editorial%20photography%20with%20cool%20neutral%20tones&width=640&height=360&seq=drama-ep07-cover-2024&orientation=landscape',
    airDate: '2024-03-11',
    director: '沈亦航',
    writer: '周晚棠 / 林澈',
    duration: '45分钟',
    synopsis:
      '因为旧照片和工作上的分歧，林夏与母亲爆发了近年最激烈的一次争吵。赵慧兰一句「你根本不知道我为你放弃了什么」，让林夏震惊又困惑。陈默本想调和，却因为信息不全而越帮越忙。',
    highlight: '母女对峙的长镜头，演出了最真实的窒息感。',
    actorIds: [1, 2, 3],
  },
  {
    id: 8,
    number: 8,
    title: '雨夜',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20still%20from%20a%20modern%20Chinese%20family%20drama%2C%20a%20young%20man%20standing%20in%20heavy%20rain%20outside%20an%20apartment%20building%20at%20night%2C%20street%20lamp%20glow%20reflected%20on%20wet%20pavement%2C%20cold%20blue%20tones%20with%20warm%20window%20lights%2C%20shallow%20depth%20of%20field%2C%20lonely%20emotional%20mood%2C%20editorial%20photography&width=640&height=360&seq=drama-ep08-cover-2024&orientation=landscape',
    airDate: '2024-03-12',
    director: '沈亦航',
    writer: '周晚棠 / 林澈',
    duration: '45分钟',
    synopsis:
      '陈默与林夏在争吵后失联。暴雨之夜，他独自站在楼下等了一整宿，只为说一句道歉；而楼上的赵慧兰隔着窗户看完了全程。第二天清晨，她第一次主动给陈默开了门，也第一次愿意坐下来，讲一段属于她自己的故事。',
    highlight: '雨夜守候与母亲开门的对照，是全剧的转折点。',
    actorIds: [1, 2, 3],
  },
  {
    id: 9,
    number: 9,
    title: '坦白前夜',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20still%20from%20a%20modern%20Chinese%20family%20drama%2C%20a%20mother%20and%20daughter%20sitting%20side%20by%20side%20on%20a%20windowsill%20at%20night%2C%20city%20lights%20bokeh%20behind%2C%20soft%20warm%20lamp%2C%20gentle%20sorrowful%20expressions%2C%20shallow%20depth%20of%20field%2C%20intimate%20quiet%20mood%2C%20editorial%20photography%20with%20warm%20indoor%20tones&width=640&height=360&seq=drama-ep09-cover-2024&orientation=landscape',
    airDate: '2024-03-13',
    director: '沈亦航',
    writer: '周晚棠 / 林澈',
    duration: '45分钟',
    synopsis:
      '赵慧兰决定在女儿的生日这天说出全部真相，却在开口前反复犹豫。林夏察觉母亲的异样，母女二人并肩坐在窗前，谈起这些年各自的委屈。有些话尚未说出口，理解却已经悄悄开始。',
    highlight: '一场没有台词的窗边戏，把两代人的距离拉到最近。',
    actorIds: [2, 3, 5],
  },
  {
    id: 10,
    number: 10,
    title: '真相边缘',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20still%20from%20a%20modern%20Chinese%20family%20drama%2C%20several%20people%20gathered%20in%20a%20bright%20living%20room%20in%20tense%20conversation%2C%20documents%20on%20a%20coffee%20table%2C%20cool%20daylight%2C%20serious%20expressions%2C%20shallow%20depth%20of%20field%2C%20dramatic%20restrained%20mood%2C%20editorial%20photography%20with%20neutral%20cool%20tones&width=640&height=360&seq=drama-ep10-cover-2024&orientation=landscape',
    airDate: '2024-03-14',
    director: '沈亦航',
    writer: '周晚棠 / 林澈',
    duration: '45分钟',
    synopsis:
      '旧友的到访让尘封的往事彻底摊开。赵慧兰年轻时曾有过另一段人生，而这段经历直接影响了她对女儿婚恋的谨慎。陈默的父母也在此刻介入，两个家庭的观念第一次正面碰撞。真相越接近，关系越脆弱。',
    highlight: '两个家庭的正面交锋，信息量拉满。',
    actorIds: [1, 2, 4, 6, 7],
  },
  {
    id: 11,
    number: 11,
    title: '各自的选择',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20still%20from%20a%20modern%20Chinese%20family%20drama%2C%20a%20young%20man%20and%20woman%20standing%20apart%20in%20a%20quiet%20park%20at%20dusk%2C%20long%20shadows%20on%20path%2C%20orange%20sky%2C%20uncertain%20expressions%2C%20shallow%20depth%20of%20field%2C%20bittersweet%20mood%2C%20editorial%20photography%20with%20warm%20dusk%20tones&width=640&height=360&seq=drama-ep11-cover-2024&orientation=landscape',
    airDate: '2024-03-15',
    director: '沈亦航',
    writer: '周晚棠 / 林澈',
    duration: '45分钟',
    synopsis:
      '真相揭开后，每个人都站在了选择的岔路口。陈默需要在事业与感情之间做出取舍，林夏要决定是否原谅母亲的隐瞒，而赵慧兰必须面对自己多年执念的代价。没有标准答案，只有各自要承担的结果。',
    highlight: '黄昏长街上的背影，是全剧最耐人寻味的一集。',
    actorIds: [1, 2, 3, 4],
  },
  {
    id: 12,
    number: 12,
    title: '和解',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20still%20from%20a%20modern%20Chinese%20family%20drama%2C%20a%20warm%20family%20reunion%20around%20a%20dining%20table%20in%20golden%20evening%20light%2C%20reconciled%20gentle%20smiles%2C%20steaming%20tea%2C%20lush%20plants%20by%20the%20window%2C%20shallow%20depth%20of%20field%2C%20hopeful%20healing%20mood%2C%20editorial%20photography%20with%20warm%20golden%20tones&width=640&height=360&seq=drama-ep12-cover-2024&orientation=landscape',
    airDate: '2024-03-16',
    director: '沈亦航',
    writer: '周晚棠 / 林澈',
    duration: '47分钟',
    synopsis:
      '经历了一路的猜忌、坦白与选择，这个家庭终于坐下来吃了一顿平静的晚饭。赵慧兰把压在心里多年的话说了出来，也把祝福交给了女儿。故事没有童话式的圆满，却让每个人都学会了与过去和解，与彼此好好告别又好好相守。',
    highlight: '大结局的一顿晚饭，把全剧情绪温柔收束。',
    actorIds: [1, 2, 3, 4, 7, 8],
  },
];